import 'react-native-reanimated'
import React from 'react'
// import GestureHandlerRootView from 'components/GestureHandlerRootView/GestureHandlerRootView.web'

import 'config/i18n'
import { Stack } from 'expo-router'
import { useTranslationsUpdater } from 'hooks/useTranslationsUpdater'

export const unstable_settings = {
  // Ensure any route can link back to `/`
  initialRouteName: 'ui',
}

export default function DevLayout() {
  useTranslationsUpdater()

  return (
    <Stack
      initialRouteName="ui"
      screenOptions={() => ({
        header: () => <></>,
        contentStyle: { backgroundColor: '#ffffff' },
      })}
    />
  )
}
